import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component'
import BootstrapTable from 'react-bootstrap-table-next';

import * as libraryControlActions from '../../../actions/library_control'
import { checkPendingTranslation } from '../../../helpers/checkPendingTranslation';
import TranslationModal from '../../../components/translation_modal/translation_modal';

import CreateLibraryControl from '../create_library_control'
import UpdateLibraryControl from '../update_library_control'
import ConfirmArchiveLibraryControl from '../confirm_archive_library_control';
import ConfirmUnarchiveLibraryControl from '../confirm_unarchive_library_control';
import LibraryControlUtilisation from '../library_control_utilisation';
import ControlLibraryTableMenu from './control_library_table_menu';
import { ControlLibraryComponents } from '../control_library_components'
import TranslationsModal from './tanslations_modal/translations_modal'

import { getText } from '../../../helpers';

import '../../../App.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './index.css'

class ControlLibraryTable extends ControlLibraryComponents {
  constructor(props){
    super(props);

    this.state = {
      sidebarShown: false,
      language: props.language,
      languages: props.languages,
      translations: props.language.translations,
      languageName: props.language.name,
      tableColumns: this.generateColumns(),
      controls: [],
      control: null,
      controlUtilisationShown: false,
      updateControlShown: false,
      confirmArchiveShown: false,
      confirmUnarchiveShown: false,
      filters: {
        include_archived: false,
        search_term: "",
        page: 1,
        include_translation: true
      },
      defaultTagOptions: [],
      defaultOwnerOptions: [],
      controlErrors: {},
      scroll: true,
    }
  }

  componentDidMount = () => {
    this.getLibraryControlsAndRelatedRecords();
  }

  componentWillReceiveProps = (nextProps) => {
    this.handleLanguageChange(nextProps);
    this.handleLibraryControlActions(nextProps);
  };

  generateColumns = () => {
    return ([
      {
        dataField: 'control_details',
        text: getText("Library Control Details"),
        formatter: this.controlDetailsRenderer,
        headerTitle: true,
        title: true,
        headerStyle: {
          fontSize: '1.3rem'
        },
      },
      {
        dataField: 'timestamps',
        text: getText("Timestamps"),
        formatter: this.timestampsRenderer,
        headerStyle: {
          width: '14%',
          fontSize: '1.3rem'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'actions',
        text: '',
        formatter: this.actionsRenderer,
        headerStyle: {
          width: '25%',
          fontSize: '1.3rem'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ])
  }

  rowClasses = (row) => {
    const pendingTranslations = this.props.library_control.pendingTranslations;
    const selectedLanguage = localStorage.getItem('language')
    const { isPendingTranslation } = checkPendingTranslation(row, pendingTranslations, selectedLanguage);
    return isPendingTranslation ? "disabled-row": ""
  };

  render() {
    const { enabled_languages: enabledLanguages } = this.props.instanceConfig
    const { end_of_records } = this.state.translations;
    const { tableColumns, controls, controlUtilisationShown, updateControlShown, confirmArchiveShown,
      createControlShown, confirmUnarchiveShown, translationsModalShown } = this.state;
    const noDataIndicator = <span className="no-data-indication"><i className="file alternate icon"></i>{getText("No records found.")}</span>;

    return (
      <div>
        <ControlLibraryTableMenu {...this}/>
        <InfiniteScroll
          dataLength={controls.length}
          next={this.getMoreLibraryControls}
          hasMore={true}
          height={1}
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>{end_of_records}</b>
            </p>
          }
        >
          <BootstrapTable
            tdStyle={{ whiteSpace: 'normal' }}
            thStyle={{ whiteSpace: 'normal' }}
            keyField="id"
            data={ controls }
            columns={ tableColumns }
            striped
            hover
            condensed
            noDataIndication={noDataIndicator}
            defaultChecked={ false }
            rowClasses={this.rowClasses}
          />
        </InfiniteScroll>
        <div className="library-control-modals">
          {
            createControlShown &&
            <CreateLibraryControl
              control={this.state.control}
              controlErrors={this.state.controlErrors}
              defaultTagOptions={this.state.defaultTagOptions}
              defaultOwnerOptions={this.state.defaultOwnerOptions}
              updateOwners={this.updateOwners}
              createNewOwner={this.createNewOwner}
              removeOwner={this.removeOwner}
              updateTags={this.updateTags}
              createNewTag={this.createNewTag}
              removeTag={this.removeTag}
              handleControlChange={this.handleControlChange}
              hideCreateControl={this.hideCreateControl}
              createLibraryControl={this.createLibraryControl}
              translations={this.state.translations}
              actionType={this.props.library_control.action_type}
            />
          }
          {
            updateControlShown &&
            <UpdateLibraryControl
              control={this.state.control}
              controlErrors={this.state.controlErrors}
              defaultTagOptions={this.state.defaultTagOptions}
              defaultOwnerOptions={this.state.defaultOwnerOptions}
              updateOwners={this.updateOwners}
              createNewOwner={this.createNewOwner}
              removeOwner={this.removeOwner}
              updateTags={this.updateTags}
              createNewTag={this.createNewTag}
              removeTag={this.removeTag}
              handleControlChange={this.handleControlChange}
              hideUpdateControl={this.hideUpdateControl}
              updateLibraryControl={this.updateLibraryControl}
              translations={this.state.translations}
              actionType={this.props.library_control.action_type}
            />
          }
          {
            confirmArchiveShown &&
            <ConfirmArchiveLibraryControl
              archiveLibraryControl={this.archiveLibraryControl}
              hideConfirmArchiveControl={this.hideConfirmArchiveControl}
            />
          }
          {
            confirmUnarchiveShown &&
            <ConfirmUnarchiveLibraryControl
              unarchiveLibraryControl={this.unarchiveLibraryControl}
              hideConfirmUnarchiveControl={this.hideConfirmUnarchiveControl}
            />
          }
          {
            controlUtilisationShown &&
            <LibraryControlUtilisation
              control={this.state.control}
              hideControlUtilisation={this.hideControlUtilisation}
            />
          }
          {
            translationsModalShown &&
            <TranslationsModal
              filters={this.state.filters}
              controls={controls}
              onClose={this.hideTranslationsModal}
              showTranslationModal={this.props.showTranslationModal}
              enabledLanguages={enabledLanguages}
            />
          }
          {
            this.props.library_control.isTranslationModalShown &&
            <TranslationModal
              translation_id={this.props.library_control.translation_id}
              onClose={this.props.hideTranslationModal}
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    languages: state.language.languages,
    library_control: state.library_control,
    instanceConfig: state.instance.instanceConfig,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLibraryControls: (options) => {
      dispatch(libraryControlActions.getLibraryControls(options))
    },
    createLibraryControl: (control) => {
      dispatch(libraryControlActions.createLibraryControl(control))
    },
    updateLibraryControl: (control) => {
      dispatch(libraryControlActions.updateLibraryControl(control))
    },
    archiveLibraryControl: (control_id) => {
      dispatch(libraryControlActions.archiveLibraryControl(control_id))
    },
    unarchiveLibraryControl: (control_id) => {
      dispatch(libraryControlActions.unarchiveLibraryControl(control_id))
    },
    getControlOwners: () => {
      dispatch(libraryControlActions.getControlOwners())
    },
    getControlTags: () => {
      dispatch(libraryControlActions.getControlTags())
    },
    showTranslationModal: (translation_id) => {
      dispatch(libraryControlActions.showTranslationModal(translation_id))
    },
    hideTranslationModal: () => {
      dispatch(libraryControlActions.hideTranslationModal())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlLibraryTable);


// WEBPACK FOOTER //
// ./src/views/control_library/table/index.js